import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MessageService } from '@philips-emr/tws-core/lib/services';

@Controller({ fragment: 'root' })
export default class MainController {

  @OnMount('layout-root')
  onRootLayoutMount(): void {
    document.title = MessageService.translate('pa.application-name');
  }
}
